import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2183448b"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("label", null, "产品服务")], -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("label", null, "解决方案")], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("label", null, "关于我们")], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo-title"
}, "安徽达链物流科技有限公司", -1));
const _hoisted_5 = {
  class: "hot-link"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " 7*24小时客服热线：", -1));
const _hoisted_7 = {
  class: "tel"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "copy-right"
}, [/*#__PURE__*/_createElementVNode("label", null, [/*#__PURE__*/_createTextVNode("Copyright©2026, yunxiaobao.com All Rights Reserved."), /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/#/Integrated/index"
}, " 皖ICP备2026037048号-2"), /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.mps.gov.cn/#/query/webSearch?code=34080202003404"
}, " 皖公网安备34080202003404号")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Divider = _resolveComponent("Divider");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: _normalizeClass(["footer-content", {
      entry: _ctx.footer.showTime
    }]),
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_createElementVNode("ul", {
    class: _normalizeClass(["product", {
      entry: _ctx.footer.showTime,
      leave: _ctx.footer.showTime
    }])
  }, [_hoisted_1, _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.goLink('/freight'))
  }, "数字货运")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[1] || (_cache[1] = $event => _ctx.goLink('/product'))
  }, "数字供应链")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[2] || (_cache[2] = $event => _ctx.goLink('/figureEnertgy'))
  }, "数字能源")])], 2), _createElementVNode("ul", {
    class: _normalizeClass(["project", {
      entry: _ctx.footer.showTime
    }])
  }, [_hoisted_2, _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[3] || (_cache[3] = $event => _ctx.goLink('/product', 'coal'))
  }, "煤炭行业")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[4] || (_cache[4] = $event => _ctx.goLink('/product', 'power'))
  }, "电力行业")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[5] || (_cache[5] = $event => _ctx.goLink('/product', 'chemical'))
  }, "化工行业")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[6] || (_cache[6] = $event => _ctx.goLink('/product', 'rail'))
  }, "铁路货站")])], 2), _createElementVNode("ul", {
    class: _normalizeClass(["us", {
      entry: _ctx.footer.showTime
    }])
  }, [_hoisted_3, _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[7] || (_cache[7] = $event => _ctx.goLink('/us', 'AboutHuoda'))
  }, "关于我们")])], 2), _createElementVNode("div", {
    class: _normalizeClass(["link-us", {
      entry: _ctx.footer.showTime
    }])
  }, [_hoisted_4, _createVNode(_component_Divider, {
    class: "divider"
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaSchema, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["wx-current-media", {
        active: item.type === _ctx.currentMedialName
      }]),
      key: index
    }, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("label", _hoisted_7, _toDisplayString(item.hotline), 1)])], 2);
  }), 128))], 2)], 6), _hoisted_8], 64);
}